/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} A11y_Statement_DateInputs */

const en_a11y_statement_date = /** @type {(inputs: A11y_Statement_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Last updated: March 24, 2026`)
};

const de_a11y_statement_date = /** @type {(inputs: A11y_Statement_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stand: 24. März 2026`)
};

const fr_a11y_statement_date = /** @type {(inputs: A11y_Statement_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Derniere mise a jour : 24 mars 2026`)
};

const es_a11y_statement_date = /** @type {(inputs: A11y_Statement_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ultima actualizacion: 24 de marzo de 2026`)
};

const it_a11y_statement_date = /** @type {(inputs: A11y_Statement_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ultimo aggiornamento: 24 marzo 2026`)
};

const nl_a11y_statement_date = /** @type {(inputs: A11y_Statement_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laatst bijgewerkt: 24 maart 2026`)
};

const pl_a11y_statement_date = /** @type {(inputs: A11y_Statement_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ostatnia aktualizacja: 24 marca 2026 r.`)
};

const fi_a11y_statement_date = /** @type {(inputs: A11y_Statement_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Viimeksi päivitetty: 24. maaliskuuta 2026`)
};

const da_a11y_statement_date = /** @type {(inputs: A11y_Statement_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sidst opdateret: 24. marts 2026`)
};

const sv_a11y_statement_date = /** @type {(inputs: A11y_Statement_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Senast uppdaterad: 24 mars 2026`)
};

/**
* | output |
* | --- |
* | "Last updated: March 24, 2026" |
*
* @param {A11y_Statement_DateInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const a11y_statement_date = /** @type {((inputs?: A11y_Statement_DateInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<A11y_Statement_DateInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_a11y_statement_date(inputs)
	if (locale === "fr") return fr_a11y_statement_date(inputs)
	if (locale === "es") return es_a11y_statement_date(inputs)
	if (locale === "it") return it_a11y_statement_date(inputs)
	if (locale === "nl") return nl_a11y_statement_date(inputs)
	if (locale === "pl") return pl_a11y_statement_date(inputs)
	if (locale === "fi") return fi_a11y_statement_date(inputs)
	if (locale === "da") return da_a11y_statement_date(inputs)
	if (locale === "sv") return sv_a11y_statement_date(inputs)
	return en_a11y_statement_date(inputs)
});